// extracted by mini-css-extract-plugin
module.exports = {"Section":"style_Section__Tt1Mg","Alternate":"style_Alternate__zXZzP","NoPadding":"style_NoPadding__2rCHR"};